import styled from 'vue-styled-components';

const theme = { font: String };

const ThemedTitle = styled('section', theme)`
    border-bottom: 1px solid #cbcbcb;
    padding: 10px 0;
    background: #fff;
    text-align: center;
    font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
    font-weight: 600; 
    letter-spacing: -0.41px;
`;

export default ThemedTitle
